import { render, staticRenderFns } from "./shelf.vue?vue&type=template&id=76d1c738&scoped=true&"
import script from "./shelf.vue?vue&type=script&lang=js&"
export * from "./shelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d1c738",
  null
  
)

export default component.exports